<template>
  <BaseGoogleMaterialIcon
    v-bind="$attrs"
    v-on="$listeners"
    :styleConfig="styleConfig"
  />
</template>

<script>
  import BaseGoogleMaterialIcon from '@base/v2/base-google-material-icon'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  /*
  To change color and fontSize from component which use this component,
  use v-bind="{ color: 'xxx', fontSize: 'yyy' }" or color="xxx" fontSize="yyy"
  instead of :style="{ color: 'xxx', fontSize: 'yyy' }".
  */
  export default {
    name: 'GoogleMaterialIconPrimary',
    inheritAttrs: false,
    components: {
      BaseGoogleMaterialIcon,
    },
    props: {
      disableCursor: {
        type: Boolean,
        reuqired: false,
        default: false,
      },
    },
    data: function () {
      return {
        styleConfig: {
          container: {
            userSelect: 'none',
          },
          innerContainer: {},
          italic: {
            ...(this.disableCursor ? {} : {
              cursor: {
                '': 'pointer',
                disabled: 'default',
              },
            }),
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.italic,
        {
          color: {
            '': this.color.dark3(),
            disabled: this.color.dark4(),
          },
          fontSize: '14px',
        },
      );

      if (this.$attrs.color) {
        this.styleConfig.italic.color = this.$attrs.color;
      }
      if (this.$attrs.fontSize) {
        this.styleConfig.italic.fontSize = this.$attrs.fontSize;
      }
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
